export default {
  getOrder: {
    method: 'post',
    url: '/report/order'
  },
  getVehicle: {
    method: 'post',
    url: '/report/vehicle'
  },
  getDriver: {
    method: 'post',
    url: '/report/driver'
  },
  getCustomer: {
    method: 'post',
    url: '/report/customer'
  },
  getSale: {
    method: 'post',
    url: '/report/sale'
  },
  getSaleKpi: {
    method: 'post',
    url: '/report/sale/kpi'
  },
  getPartner: {
    method: 'post',
    url: '/report/partner'
  },
  getDistribution: {
    method: 'post',
    url: '/report/distribution'
  },
  getRoute: {
    method: 'post',
    url: '/report/route'
  },
  getTrip: {
    method: 'post',
    url: '/report/trip'
  },
  getJourney: {
    method: 'post',
    url: '/report/journey'
  },
  getWorkflow: {
    method: 'post',
    url: '/report/workflow'
  },
  getOpportunity: {
    method: 'post',
    url: '/report/opportunity'
  },
  getTask: {
    method: 'post',
    url: '/report/task'
  },
  getTollStation: {
    method: 'post',
    url: '/report/toll-station'
  },
  getTollStationVehicle: {
    method: 'post',
    url: '/report/toll-station-vehicle'
  }

}
